<div  style="width: 100%; text-align: center;" >
    <div


class="contentContainer" style="margin-top: 100px;">

    <h1 style="text-align: center;">LOGIN WITH YOUR PROPERTY SMART CARD NO:</h1>
    <!--
    <h4>
        <span>or&nbsp;</span>
        <span (click)="aadhaarLogin()" style="cursor: pointer; text-decoration: underline;">[ Click here to Login with Aadhaar ]</span>
    </h4>
    -->

    <DIV class="appLabel" >16 DIGIT SMART CARD NUMBER</DIV>
    <input type="text" class="appInput" maxlength="16" name="txtPropertyId" id="txtPropertyId" [(ngModel)]="login.cardnumber" style="width: 200PX; text-align: center;">
    <DIV class="appLabel" >USER ID</DIV>
    <input type="text" maxlength="8" class="appInput" name="txtUserId" id="txtUserId" [(ngModel)]="login.bearerid" style="width: 100PX; text-align: center;">
    <DIV class="appLabel" >PIN</DIV>
    <input type="password" maxlength="6" class="appInput" name="txtPin" id="txtPin" style="width: 100px;text-align: center;" [(ngModel)]="login.pin">
    <div class="appButtonBar">
    <input type="submit"  class="appButton" name="cmdSubmit" id="cmdSubmit" style="width: 100px;" (click)="onLoginSubmit()" value="LOGIN">
    </div>
    <DIV class="appLabel" style="color: red;" >{{this.errMessage}}</DIV>
</div>
</div>